import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../app/guards'

// Received cheques are read with sales.read, issued ones with purchasing.read (ADR-046).
export const Route = createFileRoute('/_app/cheques')({
  staticData: { crumb: 'cheques' },
  beforeLoad: ({ context }) => requireAnyPermission(context.session, 'sales.read', 'purchasing.read'),
  component: Outlet,
})
